/**
 * Условное логирование - работает только в development режиме
 */

const isDev = import.meta.env.DEV;

interface Logger {
  debug: (...args: unknown[]) => void;
  info: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
  error: (...args: unknown[]) => void;
  log: (...args: unknown[]) => void;
}

function createLogger(module: string): Logger {
  const prefix = `[${module}]`;

  const noop = () => {};

  return {
    debug: isDev ? (...args: unknown[]) => console.debug(prefix, ...args) : noop,
    info: isDev ? (...args: unknown[]) => console.info(prefix, ...args) : noop,
    warn: isDev ? (...args: unknown[]) => console.warn(prefix, ...args) : noop,
    error: (...args: unknown[]) => console.error(prefix, ...args), // errors always logged
    log: isDev ? (...args: unknown[]) => console.log(prefix, ...args) : noop,
  };
}

// Pre-configured loggers for common modules
export const chatLogger = createLogger('ChatPage');
export const apiLogger = createLogger('api-pb');
export const authLogger = createLogger('auth');

export { createLogger };
export default createLogger;
